import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { GradeChangeCodeMap } from './interface/grade-change-code-map.interface';

@Injectable()
export class GradeChangeCodeMapService {
    constructor(private http: HttpClient) {}

    get(
        gradeBanner: string,
        gradeIGrade: string,
        changeCode: string,
        messageType: string
    ): Observable<GradeChangeCodeMap> {
        return this.http.get<GradeChangeCodeMap>(
            '/api/gradeChangeCodeMap/' + gradeBanner + '/' + gradeIGrade + '/' + changeCode + '/' + messageType
        );
    }
}
